export default __webpack_public_path__ + "static/media/login-decoration-start.bd48e2ef.svg";